import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const ReturnedIcon = (props) => {
  const { themeName, getThemeColor, getThemeColorForTab} = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M9.8335 4.5V1.5L6.0835 5.25L9.8335 9V6C12.316 6 14.3335 8.0175 14.3335 10.5C14.3335 12.9825 12.316 15 9.8335 15C7.351 15 5.3335 12.9825 5.3335 10.5H3.8335C3.8335 13.815 6.5185 16.5 9.8335 16.5C13.1485 16.5 15.8335 13.815 15.8335 10.5C15.8335 7.185 13.1485 4.5 9.8335 4.5Z"
        // fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
        fill={getThemeColorForTab(props.active)}
      />
    </svg>
  );
};

export default ReturnedIcon;
